import React from 'react'

export default function Terms() {
  return (
    <div className="mx-auto max-w-4xl px-4 py-12 text-white">
      <h1 className="text-4xl font-bold">Terms of Service</h1>

      <p className="mt-4 text-white/60 text-sm">
        Last Updated: May 10, 2026
      </p>

      <p className="mt-6 text-white/70 leading-7">
        Welcome to Delta Reloaded. By accessing, downloading, creating an
        account, or using any part of our game, website, services, Discord, or
        community platforms, you agree to these Terms of Service. If you do not
        agree with these Terms, please do not use our services.
      </p>

      <div className="mt-10 space-y-10">

        <section>
          <h2 className="text-2xl font-semibold">1. Acceptance of Terms</h2>
          <div className="mt-4 space-y-3 text-white/70 leading-7">
            <p>
              By using Delta Reloaded, you confirm that you are at least 13
              years old or meet the minimum legal age required in your country.
            </p>
            <p>
              If you are under 18, you must have permission from a parent or
              legal guardian.
            </p>
          </div>
        </section>

        <section>
          <h2 className="text-2xl font-semibold">2. Changes to These Terms</h2>
          <p className="mt-4 text-white/70 leading-7">
            We may update or modify these Terms at any time to improve the game,
            protect the community, or comply with legal requirements. Continued
            use of Delta Reloaded after changes means you accept the updated
            Terms.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold">3. User Accounts</h2>
          <div className="mt-4 space-y-3 text-white/70 leading-7">
            <p>
              You are responsible for maintaining the security of your account
              and login information.
            </p>
            <p>
              You may not share, sell, transfer, or give access to your account
              to anyone else.
            </p>
            <p>
              We reserve the right to suspend or terminate accounts that violate
              these Terms.
            </p>
          </div>
        </section>

        <section>
          <h2 className="text-2xl font-semibold">4. Fair Play & Community Rules</h2>
          <div className="mt-4 space-y-3 text-white/70 leading-7">
            <p>You may NOT:</p>

            <ul className="list-disc pl-6 space-y-2">
              <li>Cheat, hack, exploit, or use unauthorized software.</li>
              <li>Use scripts, bots, macros, or modified clients.</li>
              <li>Abuse bugs or glitches for unfair advantages.</li>
              <li>Harass, threaten, or bully other players.</li>
              <li>Use offensive names, hate speech, or inappropriate content.</li>
              <li>Attempt to attack, crash, or disrupt servers or services.</li>
              <li>Impersonate developers, moderators, or staff members.</li>
            </ul>

            <p>
              Violating these rules may result in temporary suspensions,
              permanent bans, or account termination without warning.
            </p>
          </div>
        </section>

        <section>
          <h2 className="text-2xl font-semibold">5. In-Game Content & Purchases</h2>
          <div className="mt-4 space-y-3 text-white/70 leading-7">
            <p>
              Delta Reloaded may include cosmetics, unlockables, battle passes,
              premium content, and virtual items.
            </p>

            <p>
              All virtual items remain the property of Delta Reloaded and are
              licensed for in-game use only.
            </p>

            <p>
              Unless required by law, purchases are non-refundable.
            </p>
          </div>
        </section>

        <section>
          <h2 className="text-2xl font-semibold">6. Intellectual Property</h2>
          <div className="mt-4 space-y-3 text-white/70 leading-7">
            <p>
              All content related to Delta Reloaded including logos, artwork,
              assets, branding, music, code, animations, and website content is
              owned by Delta Reloaded or its licensors.
            </p>

            <p>You may not:</p>

            <ul className="list-disc pl-6 space-y-2">
              <li>Copy or redistribute game files.</li>
              <li>Reverse engineer the game.</li>
              <li>Reupload assets without permission.</li>
              <li>Sell or monetize Delta Reloaded content.</li>
              <li>Use our branding to impersonate the project.</li>
            </ul>
          </div>
        </section>

        <section>
          <h2 className="text-2xl font-semibold">7. Privacy</h2>
          <p className="mt-4 text-white/70 leading-7">
            By using Delta Reloaded, you understand that limited information may
            be collected to operate the game, improve services, provide
            security, and maintain anti-cheat systems. Please review our Privacy
            Policy for more details.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold">8. Server Availability</h2>
          <p className="mt-4 text-white/70 leading-7">
            We work hard to keep Delta Reloaded online and stable, but we cannot
            guarantee uninterrupted access. Servers may go offline for updates,
            maintenance, technical issues, or security reasons at any time.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold">9. Anti-Cheat & Security</h2>
          <p className="mt-4 text-white/70 leading-7">
            Delta Reloaded may use anti-cheat and security systems to protect
            fair gameplay. Attempting to bypass or interfere with these systems
            may result in permanent bans or legal action.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold">10. Disclaimer</h2>
          <p className="mt-4 text-white/70 leading-7">
            Delta Reloaded is provided "as is" and "as available." We do not
            guarantee uninterrupted service, bug-free gameplay, or permanent
            availability of any content or features.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold">11. Limitation of Liability</h2>
          <p className="mt-4 text-white/70 leading-7">
            To the maximum extent allowed by law, Delta Reloaded and its team
            are not liable for lost progress, lost accounts, downtime, data
            loss, or any indirect damages related to use of the game or website.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold">12. Contact</h2>
          <p className="mt-4 text-white/70 leading-7">
            If you have questions about these Terms, please contact us through
            the official website:
          </p>

          <a
            href="https://deltareloaded.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="mt-3 inline-block text-cyan-400 hover:text-cyan-300 transition"
          >
            https://deltareloaded.com/
          </a>
        </section>

      </div>
    </div>
  )
}
